import './Loading.scss'
const Loading = () => {
  return (
    <div className='loader__container' style={{ width: '100%' }}>
      <div className='lds-roller'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}

export default Loading
